import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=afd69eea&scoped=true&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"
import style0 from "./pricehelp.vue?vue&type=style&index=0&id=afd69eea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd69eea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('afd69eea')) {
      api.createRecord('afd69eea', component.options)
    } else {
      api.reload('afd69eea', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=afd69eea&scoped=true&", function () {
      api.rerender('afd69eea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2V96e0qqhf1v3/JS/pricehelp.vue"
export default component.exports